"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDirection;
function getDirection(joystickPos) {
  const xAxis = joystickPos[0];
  const yAxis = joystickPos[1];
  const xOnCenter = xAxis < 0.1 && xAxis > -0.1;
  const yOnCenter = yAxis < 0.1 && yAxis > -0.1;
  let direction = "dummy_doNothing";
  if (xOnCenter && yAxis < -0.03) {
    direction = "stepUp";
  } else if (xOnCenter && yAxis > 0.03) {
    direction = "stepDown";
  } else if (xAxis > 0.1 && yOnCenter) {
    direction = "sidestepRight"; //"sidestepRight";
  } else if (xAxis < -0.1 && yOnCenter) {
    direction = "sidestepLeft"; //"sidestepLeft";
  } else if (!xOnCenter && !yOnCenter && xAxis < 0 && yAxis < 0) {
    direction = "turnLeft";
  } else if (!xOnCenter && !yOnCenter && xAxis > 0 && yAxis > 0) {
    direction = "turnRight";
  } else if (!xOnCenter && !yOnCenter && xAxis < 0 && yAxis > 0) {
    direction = "turnLeft";
  } else if (!xOnCenter && !yOnCenter && xAxis > 0 && yAxis < 0) {
    direction = "turnRight";
  }
  // console.log(joystickPos, "labelled as:", direction, 'direction-decider.ts', 'line: ', '3');
  return direction;
}